import PerspectiveIcon from '@/components/perspectives/PerspectiveIcon';
import PerspectiveIndicatorWrapper from './PerspectiveIndicatorWrapper';
import PerspectiveChip from './PerspectiveChip';
import ManagePerspectivesButton from './ManagePerspectivesButton';
import { type PerspectiveSummary } from '@/lib/types';
import React from 'react';

type PerspectiveIndicatorsProps = {
  perspectives: PerspectiveSummary[];
  onManage?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  manageButtonLoading?: boolean;
};

const PerspectiveIndicators = ({
  perspectives,
  onManage,
  manageButtonLoading,
}: PerspectiveIndicatorsProps) => (
  <PerspectiveIndicatorWrapper>
    {perspectives.map(perspective => (
      <PerspectiveChip
        label={perspective.name}
        perspectiveColor={perspective.color}
        avatar={
          perspective.icon === null ? undefined : (
            <PerspectiveIcon src={perspective.icon} size={32} />
          )
        }
        key={perspective.id}
      />
    ))}
    {onManage && (
      <ManagePerspectivesButton
        onClick={onManage}
        loading={manageButtonLoading ?? false}
      />
    )}
  </PerspectiveIndicatorWrapper>
);

export default PerspectiveIndicators;
